@let hasUnread = (unreadNotifications$ | async)?.length > 0;

<button
  id="notifications-trigger"
  type="button"
  [attr.data-theme]="theme()"
  class="button is-small"
  [class.has-unread]="hasUnread"
  [class.is-active]="notificationsVisible()"
  (click)="showNotificationsClick()">
  <svg
    width="24"
    height="24"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.99988 3.50027C5.95075 3.50027 3.2659 6.19623 3.2659 9.78351V15.9985L2.39494 17.1572H15.6048L14.7338 15.9985V9.78351C14.7338 6.19623 12.049 3.50027 8.99988 3.50027ZM1.52397 9.78351C1.52397 5.54147 4.75339 1.89052 8.99988 1.89052C13.2464 1.89052 16.4758 5.54147 16.4758 9.78351V15.5438L17.8607 17.5254C18.0337 17.773 18.0465 18.0882 17.8939 18.3471C17.7414 18.6059 17.448 18.767 17.129 18.767H0.870968C0.552045 18.767 0.258625 18.6059 0.106085 18.3471C-0.0464545 18.0883 -0.0337168 17.7731 0.13929 17.5255L1.52397 15.5439V9.78351Z"
        fill="#1E1B31"
        class="bell-icon" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 3.21902C8.51897 3.21902 8.12903 2.85867 8.12903 2.41415V0.80439C8.12903 0.359868 8.51897 -0.000488301 9 -0.000488281C9.48102 -0.000488262 9.87096 0.359868 9.87096 0.80439V2.41415C9.87096 2.85867 9.48102 3.21902 9 3.21902Z"
        fill="#1E1B31"
        class="bell-icon" />
      <path
        d="M9.29035 21.9995C10.5731 21.9995 11.6129 21.0386 11.6129 19.8532H6.96777C6.96777 21.0386 8.00763 21.9995 9.29035 21.9995Z"
        fill="#1E1B31"
        class="bell-icon" />
    </g>
  </svg>
</button>

<div class="notification-hover-container">
  @for (notification of (hoverNotifications$ | async)?.slice(0, 3); track notification.uId; let i = $index) {
    <div
      class="hover-notification"
      animate.enter="enter-animation"
      animate.leave="leave-animation">
      <topo-notification-hover [notification]="notification" />
    </div>
  }
</div>

<topo-notification-sidebar></topo-notification-sidebar>
